module.exports = __webpack_public_path__ + "static/media/ding.83f25877.png";